<template>
    <div class="title-input">
        Attività premiante
    </div>
    <ul class="nav nav-tabs" v-if="campaigns.length > 0">
        <li v-for="campaign in campaigns" :key="campaign.uuid" class="nav-item nav-title">
            <a class="nav-link text-nowrap" @click.prevent="setActive(campaign.uuid), showNew = false"
                :class="{ active: isActive(campaign.uuid) }" href="#" :title="campaign.name">
                <span :class="{ 'truncate-text': !isActive(campaign.uuid) }">
                    {{ campaign.name }}
                </span>
            </a>
        </li>
    </ul>


    <div class="tab-content p-3">
        <div v-for="campaign in campaigns" :key="campaign.uuid" v-show="isActive(campaign.uuid)">
            <div v-if="!showNew && !campaign.activity?.uuid">
                <div v-if="getError">{{ getError }}</div>
                <div v-else class="d-flex justify-content-center w-100">
                    <ButtonComponent v-if="campaign.locked" text="Sblocca" class="bg-white" type="regular"
                        style="width: 50%;" @handleClick="handleLocked(campaign)" />
                    <ButtonComponent v-else text="Crea attività" class="bg-white" type="regular" style="width: 50%;"
                        @handleClick="() => showNew = true" />
                </div>
            </div>
            <div v-else class="d-flex flex-row w-100">
                <div class="flex-1">
                    <div class="d-flex flex-row w-100">
                        <div class="premialita-text width-110">
                            Assegna
                        </div>
                        <div style="padding-right: 0;">
                            <input type="number" class="premialita-input width-48" v-model="campaign.activity.points"
                                @input="campaign.activity.points = validateNumericInput(campaign.activity.points)">
                        </div>
                        <div class="premialita-text" style="padding-left: 0;">
                            punti
                        </div>
                    </div>
                    <div class="d-flex flex-row w-100">
                        <div class="premialita-text width-110">
                            Per un minimo di
                        </div>
                        <div style="padding-right: 0;">
                            <input type="number" class="premialita-input width-48"
                                v-model="campaign.activity.minStepNum"
                                @input="campaign.activity.minStepNum = validateNumericInput(campaign.activity.minStepNum)">
                        </div>
                        <div class="premialita-text" style="padding-left: 0;">
                            tappe
                        </div>
                    </div>
                </div>
                <div class="flex-1 d-flex justify-content-end">
                    <ButtonComponent v-if="campaign.locked" text="Sblocca" class="bg-white" type="regular"
                        style="width: 50%;" @handleClick="handleLocked(campaign)" />
                    <div v-else class="d-flex gap-2">
                        <div v-if="showNew || campaign.activity?.uuid">
                            <ButtonComponent text="Salva" class="bg-white" type="regular"
                                @handleClick="handleSave(campaign)" />
                        </div>
                        <div v-if="campaign.activity?.uuid">
                            <ButtonComponent text="" type="remove" @handleClick="onModal(campaign.activity.uuid)" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Validate Modal -->
    <widget-container-modal />
</template>
<script setup>
/* eslint-disable no-undef, no-unused-vars */

import { ref, computed, onMounted } from 'vue';
import axios from 'axios';
import ButtonComponent from '@/components/Button.vue'
import ConfirmModal from '@/components/DeleteModal.vue'
import { container as WidgetContainerModal, openModal, closeModal } from "jenesius-vue-modal";
import { useToast } from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-sugar.css';

const emit = defineEmits(['onUpdate'])
const props = defineProps({
    activities: { type: Array, required: true },
    baseUrl: { type: String, required: true },
    token: { type: String, required: true },
    itineraryId: { type: String, required: true }
})

const $toast = useToast();
const getError = ref(null);
const isLoading = ref(false);
const activeItem = ref('')
const showNew = ref(false)
const campaigns = ref([])

const isActive = menuItem => activeItem.value === menuItem
const setActive = menuItem => (activeItem.value = menuItem)

const validateNumericInput = (value) => {
    if (value > 999) return 999
    if (value < 0) return 0
    return value
}

const onModal = async (value) => {
    const modal = await openModal(ConfirmModal, {
        modalTitle: 'Rimozione attività',
        modalContent: "Stai per <u><b>rimuovere</b></u> un'attività al momento visibile sull'app di Musei Italiani. Se procedi l'attività verrà eliminata e tutti i suoi dati andranno persi.<br/>Vuoi procedere?"
    });
    modal.on('ModalConfirm', () => {
        handleDelete(value);
    });
}

const handleLocked = async (campaign) => {
    const modal = await openModal(ConfirmModal, {
        modalTitle: 'Avvertimento!',
        modalContent: 'Sei sicuro di voler effettuare modifiche per una campagna in corso di promozione?'
    });
    modal.on('ModalConfirm', () => {
        closeModal()
        campaign.locked = false
    });
}

const handleDelete = async (activityId) => {
    isLoading.value = true
    try {
        await axios.delete(`${props.baseUrl}/v1/private/itineraries/${props.itineraryId}/activity/${activityId}`, {
            headers: {
                Authorization: `Bearer ${props.token}`,
            },
        })

        emit('onUpdate')
    } catch (error) {
        console.log(error);
        getError.value = error;
        $toast.error(error.response.data.title, { position: 'top-right' });
    } finally {
        closeModal();
        isLoading.value = false
    }
};

const handleSave = async (value) => {
    isLoading.value = true

    let method = 'post'
    let message = 'Attività creata con successo'

    if (value.activity?.uuid) {
        method = 'put'
        message = 'Attività aggiornata con successo'
    }

    try {
        const doc = {
            campaignId: value.uuid,
            points: value.activity.points,
            minStepNum: value.activity.minStepNum,
            status: 'PUBLISHED'
        }

        const base = `${props.baseUrl}/v1/private/itineraries/${props.itineraryId}/activity`;
        const activityId = value.activity?.uuid ? `/${value.activity.uuid}` : '';

        const config = {
            method,
            url: `${base}${activityId}`,
            data: doc,
            headers: {
                Authorization: `Bearer ${props.token}`
            },
        };

        const res = await axios(config);

        if (res.status === 200 || res.status === 201) {
            $toast.success(message, { position: "top-right" });
            emit('onUpdate')
        }
    } catch (error) {
        console.error(error)
        getError.value = error
        $toast.error(error.response.data.title, { position: 'top-right' });
    } finally {
        isLoading.value = false
    }
}


const fetchCampains = async () => {
    isLoading.value = true;
    try {
        const response = await axios.get(`${props.baseUrl}/v1/private/campaigns`, {
            params: {
                orderBy: 'campaignStarts',
                orderDir: 'desc'
            },
            headers: {
                Authorization: `Bearer ${props.token}`,
            },
        });

        campaigns.value = response.data.results
            .filter(campaign => campaign.expired === false)
            .map(({ uuid, name, expired, status }) => ({
                uuid,
                name,
                expired,
                activity: { points: 0, minStepNum: 0 },
                status,
                locked: status.name === 'PUBLISHED' // lo allineo per sicurezza con il campo status (se pubblicato deve essere locked)
            }));

        activeItem.value = campaigns.value[0]?.uuid || ''
        getError.value = null;
    } catch (error) {
        getError.value = error;
    } finally {
        isLoading.value = false;
    }
}

onMounted(async () => {
    await fetchCampains()
    if (props.activities.length > 0) {
        props.activities.map(activity => {
            campaigns.value.map(campaign => {
                if (activity.campaign.uuid === campaign.uuid) campaign.activity = activity
            })
        })
    }
})
</script>
<style>
.width-110 {
    width: 110px;
}

.width-48 {
    width: 48px !important;
}

.truncate-text {
    display: inline-block;
    max-width: 120px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    vertical-align: middle;
}
</style>